import { ChevronRight, MapPin, Package, Settings } from "lucide-react";
import { Link } from "react-router-dom";
import { Card } from "../components/ui/Card";
import { CampaignCalendar } from "../features/campaigns/CampaignCalendar";
import { OnboardingChecklist } from "../features/onboarding/OnboardingChecklist";

const SHORTCUTS = [
	{
		to: "/products",
		label: "Products",
		description: "Browse and search the synced catalog",
		icon: Package,
	},
	{
		to: "/locations",
		label: "Locations",
		description: "Stock locations and available units",
		icon: MapPin,
	},
	{
		to: "/settings",
		label: "Settings",
		description: "Store details and catalog sync",
		icon: Settings,
	},
];

export const HomePage = () => (
	<div className="space-y-8">
		<div>
			<h2 className="text-xl font-semibold tracking-tight text-ink">Overview</h2>
			<p className="mt-1 text-sm text-ink-muted">What is running now and what is coming up next.</p>
		</div>

		<OnboardingChecklist />

		<CampaignCalendar />

		<div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
			{SHORTCUTS.map((shortcut) => (
				<Link key={shortcut.to} to={shortcut.to} className="group">
					<Card className="flex h-full items-start gap-3 transition-colors group-hover:border-line-strong">
						<div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-raised">
							<shortcut.icon className="h-4 w-4 text-ink-muted" strokeWidth={1.75} />
						</div>
						<div className="min-w-0 flex-1">
							<p className="text-sm font-medium text-ink">{shortcut.label}</p>
							<p className="mt-0.5 text-xs text-ink-muted">{shortcut.description}</p>
						</div>
						<ChevronRight
							className="h-4 w-4 shrink-0 text-ink-faint transition-transform group-hover:translate-x-0.5"
							strokeWidth={1.75}
						/>
					</Card>
				</Link>
			))}
		</div>
	</div>
);
